import { tns } from 'tiny-slider/src/tiny-slider'

const initializeHowItWorksHover = () => {
  const stepsSelector = '.homepage--how-it-works .step--content'
  const steps = document.querySelectorAll(stepsSelector)
  const firstStep = steps[0]

  steps.forEach((step) => {
    step.addEventListener('mouseenter', ({ target }) => {
      const alreadyActive = target.classList.contains('active')
      if (!alreadyActive) {
        const activeStep = document.querySelector(`${stepsSelector}.active`)
        activeStep.classList.remove('active')
        activeStep.previousElementSibling.classList.remove('active')
        target.previousElementSibling.classList.add('active')
        target.classList.add('active')
      }
    })

    step.addEventListener('mouseexit', ({ target }) => {
      target.classList.remove('active')
      target.previousElementSibling.classList.remove('active')
      firstStep.previousElementSibling.classList.add('active')
      firstStep.classList.add('active')
    })
  })
}

const initializeHowItWorksSlider = () => {
  const stepContainerSelector = '.homepage--how-it-works'
  const stepImageSelector = '.homepage--how-it-works .step--image'

  const steps = Array.from(document.querySelectorAll(stepImageSelector))

  const createSlide = () => {
    const slide = document.createElement('div')
    slide.classList = 'slide'
    return slide
  }

  const createSlides = () => {
    const slidesContainer = document.querySelector(stepContainerSelector)

    const slides = Array(steps.length)
      .fill(1)
      .map(() => createSlide())
    slides.forEach((slide, i) => {
      const slideContent = steps[i]
      const slideImage = slideContent.nextElementSibling
      slideContent.classList.remove('active')
      slidesContainer.append(slide)
      slide.append(slideContent)
      slide.append(slideImage)
    })
  }

  createSlides()

  tns({
    container: '.homepage--how-it-works',
    controlsPosition: 'bottom',
    navPosition: 'bottom',
    mouseDrag: true,
    controlsContainer: '.slider--controls',
    loop: false,
  })
}

export const initializeHowItWorks = () => {
  const smallScreen = window.matchMedia('(max-width: 65em)')
  if (smallScreen.matches) {
    initializeHowItWorksSlider()
  } else {
    initializeHowItWorksHover()
  }
}
